import { IVenueMapOverlay } from "./venueMapOverlay.interface";


export function createVenueMapTilesOverlay() {
  return class VenueMapTilesOverlay extends google.maps.ImageMapType implements IVenueMapOverlay {
    id: number;
    level: number = 0;

    constructor(id: number, options: google.maps.ImageMapTypeOptions) {
      super(options);
      this.id = id;
    }

    setLevel(level: number) {
      this.level = level;
    }

    getLevel(): number {
      return this.level;
    }
  }
}


